import { createApp } from 'vue';

import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import '@/common/http/request';
// eslint-disable-next-line import/named
import { debounce } from 'lodash';
// import { VxeTable, VxeColumn, Edit } from 'vxe-table';

// 表格样式
import { VxeTable, VxeColumn } from 'vxe-table';
// 引入 platform 项目中的插件（融合部分）
import DataVVue3 from '@kjgl77/datav-vue3';
import V3DragZoom from 'v3-drag-zoom';
import 'v3-drag-zoom/dist/style.css';
import vue3SeamlessScroll from 'vue3-seamless-scroll';
import { VApp } from 'vuetify/components';
import App from '@/App.vue';
import { router } from '@/router/index';
import pinia from '@/store';
import useStaticDictStore from '@/store/staticDict';

import vuetify from '@/plugins/vuetify';

// 表格样式
import 'vxe-table/lib/style.css';
// layui样式
import '@layui/layui-vue/lib/index.css';
// vant样式
import 'vant/lib/index.css';

import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
// element-plus 按需导入缺少的样式
import 'element-plus/theme-chalk/el-loading.css';
import 'element-plus/theme-chalk/el-message.css';
import 'element-plus/theme-chalk/el-message-box.css';
import 'element-plus/theme-chalk/el-notification.css';
import 'element-plus/theme-chalk/el-cascader.css';
import 'element-plus/theme-chalk/el-cascader-panel.css';
import 'element-plus/theme-chalk/el-tree.css';
import 'element-plus/theme-chalk/el-date-picker.css';
import 'element-plus/theme-chalk/el-input-number.css';
import 'element-plus/theme-chalk/el-switch.css';

// 其它样式
import '@/assets/online-icon/iconfont.css';
// 静态字典
import * as staticDict from '@/common/staticDict/index';
import * as olineDicgt from '@/common/staticDict/online';
import * as flowDict from '@/common/staticDict/flow';

import { ANY_OBJECT } from '@/types/generic';
import { permissionDirective } from '@/common/directives/permission';

// vxe-table设置
function useTable(app: ANY_OBJECT) {
  // app.use(VxeTable).use(VxeColumn).use(Edit);
  app.use(VxeTable).use(VxeColumn);
}
// 静态字典设置
function useStaticDict(app: ANY_OBJECT, staticDict: ANY_OBJECT) {
  if (app.config.globalProperties.StaticDict == null) {
    app.config.globalProperties.StaticDict = {};
  }
  Object.keys(staticDict).forEach(key => {
    app.config.globalProperties.StaticDict[key] = staticDict[key];
  });
}
// webpack需要重写ResizeObserver，否则会报错
const resizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends resizeObserver {
  constructor(callback) {
    callback = debounce(callback, 10);
    super(callback);
  }
};

// 静默处理路由导航中止错误（如 iframe hash 变化触发的误导航）
window.addEventListener('unhandledrejection', event => {
  const msg: string = event?.reason?.message ?? '';
  if (
    msg.includes('Navigation aborted') ||
    msg.includes('Navigation cancelled') ||
    msg.includes('Redirected when going from')
  ) {
    event.preventDefault();
  }
});

const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
useStaticDict(app, staticDict);
useStaticDict(app, olineDicgt);
useStaticDict(app, flowDict);

app.component('v-app', VApp);
// 全局注册 v-permission 指令，用于按 permissionList 控制按钮/容器显隐
app.directive('permission', permissionDirective);
// 插件注册
app
  .use(vuetify)
  .use(pinia)
  .use(router)
  .use(useTable)
  .use(DataVVue3)
  .use(V3DragZoom)
  .use(vue3SeamlessScroll);

app.mount('#app');
// 设置静态字典
const staticDictStore = useStaticDictStore();
staticDictStore.setStaticDict(app.config.globalProperties.StaticDict);
